import React, {useContext, useEffect, useState} from 'react';
import {LoginContext} from "./context";
import ErrorFilter from "../error/ErrorFilter";
import LoginPanel from "./LoginPanel";
import SidePanelLoginLayout from "../../layouts/SidePanelLoginLayout";

export default function MFALogin(props) {
    const {code} = props;
    const {loginMFA } = useContext(LoginContext);
    const [showError, setShowError] = useState(false);

    useEffect(()=>{
        const loginAsync = async() =>{
            return await loginMFA(code)
        }
        loginAsync().then(hasError=>{
            setShowError(hasError)
        })

},[])

    return(<>
        <SidePanelLoginLayout
            sideComponent={()=>ErrorFilter(showError)}
            mainComponent={LoginPanel}
        >
        </SidePanelLoginLayout>
    </>);
}